import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

// Garde les routes privées. `role` restreint en plus à un rôle précis (ex. "admin").
export default function ProtectedRoute({ role, admin, skipOnboarding }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="route-loading" aria-busy="true" data-testid="route-loading" />;
  if (!user) return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  // L'accès se vérifie avant l'onboarding : la console d'administration n'est
  // pas un espace joueur, et un administrateur n'a pas à choisir un jeu pour y entrer.
  // `admin` s'appuie sur is_admin (dérivé de admin_roles), et non sur le rôle
  // produit : les deux notions sont distinctes côté serveur.
  if (admin && !user.is_admin) return <Navigate to="/dashboard" replace />;
  if (role && user.role !== role) return <Navigate to="/dashboard" replace />;
  if (!user.onboarded && !skipOnboarding) return <Navigate to="/onboarding" replace />;
  return <Outlet />;
}
